import { render, staticRenderFns } from "./channel-slider.vue?vue&type=template&id=de569a40&"
import script from "./channel-slider.vue?vue&type=script&lang=js&"
export * from "./channel-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports